import { Box, Grid, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ChartCashFlow from '@/components/Base/ChartCashFlow';
import { useConsolidationPedagogicalCashFlow } from './api/getConsolidationPedagogicalCashFlow';
import { TitlePages } from '@/components/Base/TitlePage';
import KpiComponent from '@/components/Base/KpiComponent';
import { EmptyComponent } from './components/EmptyComponent';

import BarChartSaldoGrupo from '@/components/Base/BarChartSaldoGrupo';
import ColumnChartEntradasSaidas from '@/components/Base/ColumnChartEntradasSaidas';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import dayjs from 'dayjs';
import { useFluxoCaixaKpis } from '../fluxo-caixa/api/getFluxoCaixaKpis';
import CurrencyFormat from '@/utils/CurrencyFormat';
import { useFluxoCaixaGraficos } from '../fluxo-caixa/api/getFluxoCaixaGraficos';
import { useFluxoCaixaEntradaDiaADia } from '../fluxo-caixa/api/getFluxoCaixaEntradasDiaADia';
import ColumnChartEntradasDiaADia from '@/components/Base/ColumnChartEntradasDiaADia';
import { useSaldoCategoria } from '../fluxo-caixa/api/getSaldoCategoria';
import BarChartSaldoCategoria from '@/components/Base/BarChartSaldoCategoria';

export const generateLastYears = (numYears) => {
  const currentYear = dayjs().year();
  return Array.from({ length: numYears }, (_, index) => currentYear - index).reverse();
};

const CashFlowTela = () => {


  const [open, setOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));

  const daysDiff = dayjs(selectedEndDate).diff(dayjs(selectedStartDate), 'day') || null;

  const filters = {
    ...(selectedYear && { year: selectedYear }),
    ...(selectedMonth && { month: selectedMonth }),
  };

  const { data: selectedData, isFetched, isFetching } = useConsolidationPedagogicalCashFlow(filters);

  const { data: entradaData, isFetched: isFetchedEntrada, isFetching: isFetchingEntrada } = useFluxoCaixaEntradaDiaADia(filters);

  const { data: selectedKpis, isFetched: isFetchedKpis, isFetching: isFetchingKpis } = useFluxoCaixaKpis(filters);

  const { data: categoriaData, isFetched: isFetchedCategoria, isFetching: isFetchingCategoria } = useSaldoCategoria(filters);

  const {
    data: selectedGraficos,
    isFetched: isFetchedGraficos,
    isFetching: isFetchingGraficos,
  } = useFluxoCaixaGraficos(filters);


  const dataEntradasSaidas = [{ dia: 1, valor: 10.2, valor_secundario: 10.2 }];

  const dataSaldoGrupo = [
    { nome: 'Mensalidade', valor: 100, tipo: 'positivo' },
    { nome: 'Luz', valor: 50, tipo: 'negativo' },
    { nome: 'Água', valor: 30, tipo: 'negativo' },
    { nome: 'Internet', valor: 100, tipo: 'negativo' },
    { nome: 'Salário', valor: 2000, tipo: 'positivo' },
  ];

  return (
    <>
      <>
        <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <TitlePages title={'Fluxo de caixa'} />
        </Stack>

        <Box
          padding={'15px'}
          sx={{
            border: '1px solid rgba(176, 176, 176, 1)',
            background: '#fff',
            borderRadius: '14px',
          }}
        >
          <Stack flexDirection={'row'} gap={'8px'}>
            {selectedKpis && isFetchedKpis && (
              <Stack
                flexDirection="row"
                maxWidth="100%"
                gap="8px"
                style={{
                  overflowX: 'auto',
                  scrollBehavior: 'smooth',
                  scrollbarWidth: 'thin',
                  scrollbarColor: '#E04A4C #f1f1f1',
                }}
              >
                <KpiComponent
                  title={'Entradas'}
                  value={`${CurrencyFormat.format(Number(selectedKpis?.entry_value))}`}
                  sign
                  style={{ minWidth: '200px' }}
                />
                <KpiComponent
                  title={'Saídas'}
                  value={`${CurrencyFormat.format(Number(selectedKpis?.exit_value))}`}
                  sign
                  style={{ minWidth: '200px' }}
                />

                <KpiComponent
                  title={'Saldo'}
                  value={`${CurrencyFormat.format(Number(selectedKpis?.balance))}`}
                  sign
                  style={{ minWidth: '200px' }}
                />
              </Stack>
            )}
          </Stack>

          <Box marginTop={'10px'} marginBottom={'25px'}>
            <PeriodFilterDash
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              onStartDateChange={setSelectedStartDate}
              onEndDateChange={setSelectedEndDate}
              refetchDashboard={() => console.log('teste')}
              listYears={listYears}
              setSelectedYear={setSelectedYear}
              setSelectedMonth={setSelectedMonth}
              selectedYear={selectedYear}
              selectedMonth={selectedMonth}
              showPeriodFilter={false}
            />
          </Box>

          {selectedGraficos && isFetchedGraficos && ( 
            <>
              {selectedGraficos.balance_evolution?.length ? (
                <ChartCashFlow title={'Fluxo de Caixa'} data={selectedGraficos?.balance_evolution || []} />
              ) : (
                <EmptyComponent />
              )}
            </>
          )}
          <Box marginTop={'10px'} marginBottom={'25px'} />
          {entradaData && <ColumnChartEntradasDiaADia selectedData={entradaData} title={'Entrada X Saída dia a dia'} firstColor={'#28C76F'} secondColor={'#DF4A4C'} columnOne={'Entradas'} columnTwo={'Saídas'} percentageName={''}/>}
          {categoriaData?.categorias?.length && !isFetchingCategoria ? ( 
              <BarChartSaldoCategoria categories={categoriaData?.categorias} />
            ) : (
              <EmptyComponent />
            )}
          </Box>
      </>
    </>
  );
};

export default CashFlowTela;
